var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTriangle01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u0421\\u043B\\u043E\\u0439_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "15.998px",
    height: "9px",
    viewBox: "105.01 151.676 15.998 9",
    enableBackground: "new 105.01 151.676 15.998 9",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#01B454",
    d: "M120.977,151.948c-0.063-0.165-0.215-0.272-0.381-0.272h-15.174c-0.166,0-0.317,0.107-0.381,0.272 s-0.028,0.354,0.09,0.481l7.586,8.117c0.081,0.086,0.187,0.129,0.292,0.129s0.211-0.043,0.292-0.129l7.586-8.117 C121.005,152.302,121.041,152.113,120.977,151.948z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTriangle01);
export default __webpack_public_path__ + "static/media/triangle-01.00b5a937d1aa5f445be2962a7ca0f948.svg";
export { ForwardRef as ReactComponent };